import styled from 'styled-components';
import { motion } from 'framer-motion';

export const CardWrapper = styled(motion.div)`
  position: relative;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden; /* Keeps the scaled image inside the rounded corners */
  background-color: var(--primary-bg, #fff);
  -webkit-tap-highlight-color: transparent;

  /* Dynamically set grid spans based on the variant prop */
  ${({ $variant }) => {
    switch ($variant) {
      case 'large':
        return `
          grid-column: span 2; 
          grid-row: span 2;
          @media (max-width: 600px) { grid-column: span 1; grid-row: span 1; }
        `;
      case 'wide':
        return `
          grid-column: span 2; 
          grid-row: span 1;
          @media (max-width: 600px) { grid-column: span 1; }
        `;
      case 'tall':
        return `
          grid-column: span 1; 
          grid-row: span 2;
          @media (max-width: 900px) { grid-row: span 1; }
        `;
      default: // 'normal'
        return `
          grid-column: span 1; 
          grid-row: span 1;
        `;
    }
  }}
`;

export const BentoImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const BentoOverlay = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 60%);
  display: flex;
  align-items: flex-end;
  padding: 1.5rem;
  
  /* Hidden by default, fades in on hover */
  opacity: 0;
  transition: opacity 0.3s ease;

  /* Target this overlay when the parent CardWrapper is hovered */
  ${CardWrapper}:hover & {
    opacity: 1;
  }
`;

export const LocationText = styled(motion.span)`
  color: #ffffff;
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 500;
  /* Slight upward slide on hover */
  transform: translateY(10px);
  transition: transform 0.3s ease;

  ${CardWrapper}:hover & {
    transform: translateY(0);
  }
`;

/* ... KEEP YOUR EXISTING FULL SCREEN OVERLAY STYLES BELOW THIS ... */

/* --- FULL SCREEN OVERLAY STYLES (Duplicated from ArtCard) --- */

export const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--matting-bg); 
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

export const FullScreenImage = styled(motion.img)`
  max-width: 90vw;
  max-height: 60vh; 
  /* Crucial: switch back to contain to reveal true aspect ratio */
  object-fit: contain; 
  margin-bottom: 2rem;
  border-radius: 4px;
  box-shadow: var(--gallery-shadow);
`;

export const FullScreenTextContainer = styled(motion.div)`
  text-align: center;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: var(--primary-text);
`;

export const FullScreenTitle = styled(motion.h2)`
  font-family: var(--font-heading);
  font-size: 2rem;
  margin: 0;
  font-weight: normal;
`;

export const FullScreenMeta = styled(motion.p)`
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--accent-color); 
  margin: 0;
  margin-bottom: 1rem;
`;

export const CloseButton = styled(motion.button)`
  position: fixed;
  top: 2rem;
  right: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem; 
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  color: var(--primary-text);
`;

export const MinimizeLine = styled(motion.div)`
  width: 24px;
  height: 2px;
  background-color: currentColor;
  border-radius: 2px; 
  display: block;
`;